import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { PesoPrecioList } from "./components/pesosprecios/list";

type Entity = models.ZonaExtendidaTarifaPrecio;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}

function validar(x: Entity) {
    const datosRep = { idUsuarioZE: x.IdRegistro };
    const rules: validation.Rules<Entity> = {
        Nombre: validation.required,
        PrecioKgExcedente: x => x.PrecioKgExcedente < 0 || x.PrecioKgExcedente == undefined ? "Obligatorio" : true,
        PrecioSobre: x => x.PrecioSobre < 0 || x.PrecioSobre == undefined ? "Obligatorio" : true,
    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class TarifaPrecioZEFormNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, validar);
    hasError = createSelectorRx(this.errors, err => validation.hasError(err));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value, onGuardar, nuevo, onChange } = this.props;
        const getField = this.getField;

        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);
        const Number = getField(kea.Number);
        const direccion = getField(kea.Number);
        const PesoPrecio = getField(PesoPrecioList);
        const hasError = this.hasError(this.props);

        return (
            <div>
                <kea.Title titulo="Tarifa precio ZE" onRegresar={() => history.go("../")} />
                {kea.autogrid(6, [
                    <Text field="Nombre" />,
                    <Number field="PrecioSobre" label="Precio por sobre" format="currency" />,
                    <Number field="PrecioKgExcedente" label="Precio Kg excedente" format="currency" />,
                ])}
                <PesoPrecio field="PesosPrecios" />

                {<h4><span>Tarifa por % para Zona Extendida</span></h4>}

                {kea.autogrid(6, [
                    <Number field="PorcentajeFlete" label="Porcentaje del flete" format="percentage" />,
                    <Number field="PorcentajeTarifaMinima" label="Tarifa mínima" format="currency" />,
                    <Check field="CobrarPorPorcentaje" label="Cobrar por Porcentaje" />
                ])}

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={hasError} />
                    </div>
                </div>
            </div>);
    }
}

export const TarifaPrecioZEForm = componentToRx(TarifaPrecioZEFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/tarifasprecio/edit/form.tsx